import * as React from "react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { HotelsProps } from "../typings";
import { HotelCard } from "../components/HotelCard";
import { UitkCardSectionSeparatorType, UitkCardTextSegment } from "uitk-react-cards";
import { HotelNameRatingAndAddress } from "src/components/flexComponents/Hotels/components/HotelNameRatingAndAddress";
import { ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { TravelersLovedHotelsCard } from "src/components/flexComponents/Hotels/components/TravelersLovedHotelsCard";
import IsomorphicCarousel from "src/components/shared/IsomorphicCarousel/IsomorphicCarousel";

export const TravelersLovedHotels = (props: HotelsProps) => {
  const flexComponent = props.flexComponent;
  const keyHelper = new ItemKeyHelper("hotels");
  const model = flexComponent.model;
  const l10n = props.l10n;
  const context = props.context;

  const hotelsWithEndorsements =
    model && model.hotels && model.hotels.filter(hotel => !!hotel.apsReviewCount);

  // Don't render the module altogether if no hotel has an endorsement count.
  if (!flexComponent || !hotelsWithEndorsements || hotelsWithEndorsements.length === 0) {
    return null;
  }

  const cardContent = (hotel: Hotel) => () => (
    <>
      <UitkCardTextSegment separator={UitkCardSectionSeparatorType.BOTTOM}>
        <HotelNameRatingAndAddress hotel={hotel} locale={context.locale} />
      </UitkCardTextSegment>
      <UitkCardTextSegment className="endorsedByTravelersText uitk-type-300">
        {l10n.formatText("hotels.endorsedByTravelers", hotel.apsReviewCount)}
      </UitkCardTextSegment>
    </>
  );

  const hotelCardProps = (hotel: Hotel) => ({
    callToActionHotelName: model.callToActionHotelName,
    context: props.context,
    l10n,
    className: "all-r-margin-three",
    hotel,
    CardContent: cardContent(hotel),
    isMobile: true,
    moduleName: "travelers-loved-hotels"
  });

  return (
    <div
      className="TravelersLovedHotels uitk-cell all-cell-1-1 all-y-padding-three"
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
      id={flexComponent.id}
    >
      <Viewport>
        <ViewSmall>
          <>
            <h2 className="uitk-type-heading-600">{model.title}</h2>
            <IsomorphicCarousel
              itemsVisible={{ sm: 1, md: 1, lg: 1 }}
              pageBy={1}
              peekWidth={24}
              buttonText={{
                nextButton: l10n.formatText("carousel.item.next"),
                prevButton: l10n.formatText("carousel.item.prev")
              }}
            >
              {hotelsWithEndorsements.map((hotel, hotelIndex) => (
                <HotelCard {...hotelCardProps(hotel)} index={hotelIndex} />
              ))}
            </IsomorphicCarousel>
          </>
        </ViewSmall>
        <ViewMedium>
          <div className="carouselMediumContainer">
            <h2 className="uitk-type-heading-600">{model.title}</h2>
            <IsomorphicCarousel
              itemsVisible={{ sm: 1, md: 1, lg: 1 }}
              pageBy={1}
              peekWidth={50}
              buttonText={{
                nextButton: l10n.formatText("carousel.item.next"),
                prevButton: l10n.formatText("carousel.item.prev")
              }}
            >
              {hotelsWithEndorsements.map((hotel, hotelIndex) => (
                <li key={keyHelper.next()}>
                  <TravelersLovedHotelsCard
                    hotelCarouselIndex={hotelIndex}
                    hotelName={hotel.hotelName}
                    endorsedBy={hotel.apsReviewCount}
                    imageUrl={hotel.hotelImageUrl}
                    hotelInfositeUrl={hotel.hotelInfositeUrl}
                  />
                </li>
              ))}
            </IsomorphicCarousel>
          </div>
        </ViewMedium>
      </Viewport>
    </div>
  );
};

export default TravelersLovedHotels;
